import { LOGO, SITE } from '../../app.const';

function Footer() {
  return (
    <footer className="Footer">
      <img className="Footer-mark" src={LOGO.mark.src} alt="" />
      <p>{SITE.footerCredit}</p>
    </footer>
  );
}

export default Footer;
